/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Approvals from '../modules/approvals/routes'
import GeneralConfig from '../modules/generalConfig/routes'
import GeneralReports from '../modules/generalReports/routes'
import HelpCenter from '../modules/helpCenter/routes'

const LoginPage = resolve => {
  require.ensure(['@/container-components/login.page'], () => {
    resolve(require('@/container-components/login.page'))
  })
}

const ForgotPasswordPage = resolve => {
  require.ensure(['@/container-components/forgotPassword.page'], () => {
    resolve(require('@/container-components/forgotPassword.page'))
  })
}

const DashboardPage = resolve => {
  require.ensure(['@/container-components/dashboard.page'], () => {
    resolve(require('@/container-components/dashboard.page'))
  })
}

const ExpenseItemPage = resolve => {
  require.ensure(['@/container-components/expense.item.page'], () => {
    resolve(require('@/container-components/expense.item.page'))
  })
}

const ExpenseTrackingItemPage = resolve => {
  require.ensure(['@/container-components/expenseTracking.item.page'], () => {
    resolve(require('@/container-components/expenseTracking.item.page'))
  })
}

const CategoriesPage = resolve => {
  require.ensure(['@/container-components/categories.page'], () => {
    resolve(require('@/container-components/categories.page'))
  })
}

const TravelTypesPage = resolve => {
  require.ensure(['@/container-components/travelTypes.page'], () => {
    resolve(require('@/container-components/travelTypes.page'))
  })
}

const AreasPage = resolve => {
  require.ensure(['@/container-components/areas.page'], () => {
    resolve(require('@/container-components/areas.page'))
  })
}

const ToReconcileExpensesPage = resolve => {
  require.ensure(['@/container-components/toReconcileExpenses.page'], () => {
    resolve(require('@/container-components/toReconcileExpenses.page'))
  })
}

const ReconciledExpensesPage = resolve => {
  require.ensure(['@/container-components/reconciledExpenses.page'], () => {
    resolve(require('@/container-components/reconciledExpenses.page'))
  })
}

const ExcludedExpensesPage = resolve => {
  require.ensure(['@/container-components/excludedExpenses.page'], () => {
    resolve(require('@/container-components/excludedExpenses.page'))
  })
}

const MissingExpensesPage = resolve => {
  require.ensure(['@/container-components/missingExpenses.page'], () => {
    resolve(require('@/container-components/missingExpenses.page'))
  })
}

const SettingsPage = resolve => {
  require.ensure(['@/container-components/settings.page'], () => {
    resolve(require('@/container-components/settings.page'))
  })
}

const ValidatorsPage = resolve => {
  require.ensure(['@/container-components/validators.page'], () => {
    resolve(require('@/container-components/validators.page'))
  })
}

const ApproverPage = resolve => {
  require.ensure(['@/container-components/approver.page'], () => {
    resolve(require('@/container-components/approver.page'))
  })
}

const CompaniesPage = resolve => {
  require.ensure(['@/container-components/companies.page'], () => {
    resolve(require('@/container-components/companies.page'))
  })
}

const UsersPage = resolve => {
  require.ensure(['@/container-components/users.page'], () => {
    resolve(require('@/container-components/users.page'))
  })
}

// const UserApplicationPage = resolve => {
//   require.ensure(['@/container-components/user.application.page'], () => {
//     resolve(require('@/container-components/user.application.page'))
//   })
// }

const ExpensesPage = resolve => {
  require.ensure(['@/container-components/expenses.page'], () => {
    resolve(require('@/container-components/expenses.page'))
  })
}

const ProjectsPage = resolve => {
  require.ensure(['@/container-components/projects.page'], () => {
    resolve(require('@/container-components/projects.page'))
  })
}

const BranchesPage = resolve => {
  require.ensure(['@/container-components/branches.page'], () => {
    resolve(require('@/container-components/branches.page'))
  })
}

const RestrictionsPage = resolve => {
  require.ensure(['@/container-components/restrictions.page'], () => {
    resolve(require('@/container-components/restrictions.page'))
  })
}

const rolesPage = resolve => {
  require.ensure(['@/container-components/roles.page'], () => {
    resolve(require('@/container-components/roles.page'))
  })
}

const WorkflowPage = resolve => {
  require.ensure(['@/container-components/workflow.page'], () => {
    resolve(require('@/container-components/workflow.page'))
  })
}

const PermissionsPage = resolve => {
  require.ensure(['@/container-components/permissions.page'], () => {
    resolve(require('@/container-components/permissions.page'))
  })
}

const substitutesPage = resolve => {
  require.ensure(['@/container-components/substitutes.page'], () => {
    resolve(require('@/container-components/substitutes.page'))
  })
}

const SubscriptionsPage = resolve => {
  require.ensure(['@/container-components/subscriptions.page'], () => {
    resolve(require('@/container-components/subscriptions.page'))
  })
}

const historyPage = resolve => {
  require.ensure(['@/container-components/history.page'], () => {
    resolve(require('@/container-components/history.page'))
  })
}

const ExpensesApprovedPage = resolve => {
  require.ensure(['@/container-components/user.expensesApproved.page'], () => {
    resolve(require('@/container-components/user.expensesApproved.page'))
  })
}

const expensesValidatePage = resolve => {
  require.ensure(['@/container-components/expensesValidate.page'], () => {
    resolve(require('@/container-components/expensesValidate.page'))
  })
}

const missingReserveExpensesPage = resolve => {
  require.ensure(['@/container-components/missingReserveExpenses.page'], () => {
    resolve(require('@/container-components/missingReserveExpenses.page'))
  })
}

const employerReportPage = resolve => {
  require.ensure(['@/container-components/employerReport.page'], () => {
    resolve(require('@/container-components/employerReport.page'))
  })
}

const reportsTypePage = resolve => {
  require.ensure(['@/container-components/reportstype.page'], () => {
    resolve(require('@/container-components/reportstype.page'))
  })
}

const NotificationsPage = resolve => {
  require.ensure(['@/container-components/notifications.page'], () => {
    resolve(require('@/container-components/notifications.page'))
  })
}

const ExpenseDetailEmployeePage = resolve => {
  require.ensure(['@/container-components/expenseDetailEmployee.page'], () => {
    resolve(require('@/container-components/expenseDetailEmployee.page'))
  })
}

const expensesRejectedPage = resolve => {
  require.ensure(['@/container-components/user.expensesRejected.page'], () => {
    resolve(require('@/container-components/user.expensesRejected.page'))
  })
}

const SatXMLDownloadPage = resolve => {
  require.ensure(['@/container-components/satXMLDownload.page'], () => {
    resolve(require('@/container-components/satXMLDownload.page'))
  })
}

const keywordsPage = resolve => {
  require.ensure(['@/container-components/keywords.page'], () => {
    resolve(require('@/container-components/keywords.page'))
  })
}

const annualExpensesReportPage = resolve => {
  require.ensure(['@/container-components/annualExpensesReport.page'], () => {
    resolve(require('@/container-components/annualExpensesReport.page'))
  })
}

const reportAnnualExpensesBranchPage = resolve => {
  require.ensure(['@/container-components/reportAnnualExpensesBranch.page'], () => {
    resolve(require('@/container-components/reportAnnualExpensesBranch.page'))
  })
}

const reportExpensesCategoryBranchPage = resolve => {
  require.ensure(['@/container-components/reportExpensesCategoryBranch.page'], () => {
    resolve(require('@/container-components/reportExpensesCategoryBranch.page'))
  })
}

const reportsByConceptPage = resolve => {
  require.ensure(['@/container-components/reportsbyconcept.page'], () => {
    resolve(require('@/container-components/reportsbyconcept.page'))
  })
}

const reportComparativePage = resolve => {
  require.ensure(['@/container-components/reportComparative.page'], () => {
    resolve(require('@/container-components/reportComparative.page'))
  })
}

const reportExpenseTrackingPage = resolve => {
  require.ensure(['@/container-components/reportExpenseTracking.page'], () => {
    resolve(require('@/container-components/reportExpenseTracking.page'))
  })
}

const expensesPayablePage = resolve => {
  require.ensure(['@/container-components/expensesPayable.page'], () => {
    resolve(require('@/container-components/expensesPayable.page'))
  })
}

const annualExpensesByEmployedReportPage = resolve => {
  require.ensure(
    ['@/container-components/annualExpensesByEmployedReport.page'],
    () => {
      resolve(
        require('@/container-components/annualExpensesByEmployedReport.page')
      )
    }
  )
}

const expensesPaid = resolve => {
  require.ensure(['@/container-components/expensesPaid.page'], () => {
    resolve(require('@/container-components/expensesPaid.page'))
  })
}

const advancesPage = resolve => {
  require.ensure(['@/container-components/advances.page'], () => {
    resolve(require('@/container-components/advances.page'))
  })
}

const contactPage = resolve => {
  require.ensure(['@/container-components/contact.page'], () => {
    resolve(require('@/container-components/contact.page'))
  })
}

const pettyCashPage = resolve => {
  require.ensure(['@/container-components/pettyCash.page'], () => {
    resolve(require('@/container-components/pettyCash.page'))
  })
}

const requestPettyCashPage = resolve => {
  require.ensure(['@/container-components/requestPettyCash.page'], () => {
    resolve(require('@/container-components/requestPettyCash.page'))
  })
}

const amexCardPage = resolve => {
  require.ensure(['@/container-components/amexCard.page'], () => {
    resolve(require('@/container-components/amexCard.page'))
  })
}

const verifyEFOSPage = resolve => {
  require.ensure(['@/container-components/verifyEFOS.page'], () => {
    resolve(require('@/container-components/verifyEFOS.page'))
  })
}

const attachFilesPage = resolve => {
  require.ensure(['@/container-components/attachFiles.page'], () => {
    resolve(require('@/container-components/attachFiles.page'))
  })
}

const reservationsPage = resolve => {
  require.ensure(['@/container-components/reservations.page'], () => {
    resolve(require('@/container-components/reservations.page'))
  })
}

const viaticRequestPage = resolve => {
  require.ensure(['@/container-components/viaticRequest.page'], () => {
    resolve(require('@/container-components/viaticRequest.page'))
  })
}

const cashierPage = resolve => {
  require.ensure(['@/container-components/cashier.page'], () => {
    resolve(require('@/container-components/cashier.page'))
  })
}

const representativesPage = resolve => {
  require.ensure(['@/container-components/representatives.page'], () => {
    resolve(require('@/container-components/representatives.page'))
  })
}

const generalSearchPage = resolve => {
  require.ensure(['@/container-components/generalSearch.page'], () => {
    resolve(require('@/container-components/generalSearch.page'))
  })
}

const advancesRequest = resolve => {
  require.ensure(['@/container-components/advancesRequest.page'], () => {
    resolve(require('@/container-components/advancesRequest.page'))
  })
}

Vue.use(Router)

function noRequireAuth(to, from, next) {
  if (!localStorage.getItem('token')) {
    next()
  } else {
    next('/dashboard')
  }
}

function requireAuth(to, from, next) {
  if (localStorage.getItem('token')) {
    next()
  } else {
    next('/')
  }
}

function handleNotFound(to, from, next) {
  next('/')
}

function logout(to, from, next) {
  if (localStorage.getItem('token')) {
    localStorage.removeItem('token')
  }
  next('/')
}

const router = new Router({
  base: '/app',
  routes: [
    {
      path: '/',
      name: 'LoginPage',
      meta: { layout: 'userpages' },
      component: LoginPage,
      beforeEnter: noRequireAuth
    },
    {
      path: '/forgot-password',
      name: 'ForgotPasswordPage',
      meta: { layout: 'userpages' },
      component: ForgotPasswordPage,
      beforeEnter: noRequireAuth
    },
    {
      path: '/dashboard',
      name: 'DashboardPage',
      component: DashboardPage,
      beforeEnter: requireAuth
    },
    {
      path: '/users',
      name: 'UsersPage',
      component: UsersPage,
      beforeEnter: requireAuth
    },
    // {
    //   path: '/user-application',
    //   name: 'UserApplicationPage',
    //   component: UserApplicationPage,
    //   beforeEnter: requireAuth
    // },
    {
      path: '/expenses/:id',
      name: 'ExpenseItemPage',
      component: ExpenseItemPage,
      beforeEnter: requireAuth
    },
    {
      path: '/expensesTracking/:id',
      name: 'ExpenseTrackingItemPage',
      component: ExpenseTrackingItemPage,
      beforeEnter: requireAuth
    },
    {
      path: '/categories',
      name: 'CategoriesPage',
      component: CategoriesPage,
      beforeEnter: requireAuth
    },
    {
      path: '/travelTypes',
      name: 'TravelTypesPage',
      component: TravelTypesPage,
      beforeEnter: requireAuth
    },
    {
      path: '/areas',
      name: 'AreasPage',
      component: AreasPage,
      beforeEnter: requireAuth
    },
    {
      path: '/toReconcileExpenses',
      name: 'ToReconcileExpensesPage',
      component: ToReconcileExpensesPage,
      beforeEnter: requireAuth
    },
    {
      path: '/reconciledExpenses',
      name: 'ReconciledExpensesPage',
      component: ReconciledExpensesPage,
      beforeEnter: requireAuth
    },
    {
      path: '/missingExpenses',
      name: 'MissingExpensesPage',
      component: MissingExpensesPage,
      beforeEnter: requireAuth
    },
    {
      path: '/excludedExpenses',
      name: 'ExcludedExpensesPage',
      component: ExcludedExpensesPage,
      beforeEnter: requireAuth
    },
    {
      path: '/settings',
      name: 'SettingsPage',
      component: SettingsPage,
      beforeEnter: requireAuth
    },
    {
      path: '/validators',
      name: 'ValidatorsPage',
      component: ValidatorsPage,
      beforeEnter: requireAuth
    },
    {
      path: '/approver',
      name: 'ApproverPage',
      component: ApproverPage,
      beforeEnter: requireAuth
    },
    {
      path: '/companies',
      name: 'CompaniesPage',
      component: CompaniesPage,
      beforeEnter: requireAuth
    },
    {
      path: '/expenses',
      name: 'ExpensesPage',
      component: ExpensesPage,
      beforeEnter: requireAuth
    },
    {
      path: '/projects',
      name: 'ProjectsPage',
      component: ProjectsPage,
      beforeEnter: requireAuth
    },
    {
      path: '/branches',
      name: 'BranchesPage',
      component: BranchesPage,
      beforeEnter: requireAuth
    },
    {
      path: '/restrictions',
      name: 'RestrictionsPage',
      component: RestrictionsPage,
      beforeEnter: requireAuth
    },
    {
      path: '/roles',
      name: 'rolesPage',
      component: rolesPage,
      beforeEnter: requireAuth
    },
    {
      path: '/workflow',
      name: 'WorkflowPage',
      component: WorkflowPage,
      beforeEnter: requireAuth
    },
    {
      path: '/permissions',
      name: 'permissionsPage',
      component: PermissionsPage,
      beforeEnter: requireAuth
    },
    {
      path: '/substitutes',
      name: 'substitutesPage',
      component: substitutesPage,
      beforeEnter: requireAuth
    },
    {
      path: '/subscriptions',
      name: 'SubscriptionsPage',
      component: SubscriptionsPage,
      beforeEnter: requireAuth
    },
    {
      path: '/history',
      name: 'historyPage',
      component: historyPage,
      beforeEnter: requireAuth
    },
    {
      path: '/approved_expenses',
      name: 'ExpensesApprovedPage',
      component: ExpensesApprovedPage,
      beforeEnter: requireAuth
    },
    {
      path: '/validate_expenses',
      name: 'expensesValidatePage',
      component: expensesValidatePage,
      beforeEnter: requireAuth
    },
    {
      path: '/missingReserveExpenses',
      name: 'missingReserveExpenses',
      component: missingReserveExpensesPage,
      beforeEnter: requireAuth
    },
    {
      path: '/employerReport',
      name: 'employerReport',
      component: employerReportPage,
      beforeEnter: requireAuth
    },
    {
      path: '/reportsType',
      name: 'reportstype',
      component: reportsTypePage,
      beforeEnter: requireAuth
    },
    {
      path: '/notifications',
      name: 'NotificationsPage',
      component: NotificationsPage,
      beforeEnter: requireAuth
    },
    {
      path: '/expenseDetailEmployee',
      name: 'ExpenseDetailEmployee',
      component: ExpenseDetailEmployeePage,
      beforeEnter: requireAuth
    },
    {
      // Misma pantalla desde el panel de usuario: sólo el empleado logueado.
      path: '/myExpenseDetail',
      name: 'MyExpenseDetail',
      component: ExpenseDetailEmployeePage,
      beforeEnter: requireAuth,
      meta: { userMode: true }
    },
    {
      path: '/rejected_expenses',
      name: 'expensesRejectedPage',
      component: expensesRejectedPage,
      beforeEnter: requireAuth
    },
    {
      path: '/annualExpensesReport',
      name: 'annualExpensesReport',
      component: annualExpensesReportPage,
      beforeEnter: requireAuth
    },
    {
      path: '/reportAnnualExpensesBranch',
      name: 'reportAnnualExpensesBranch',
      component: reportAnnualExpensesBranchPage,
      beforeEnter: requireAuth
    },
    {
      path: '/reportExpensesCategoryBranch',
      name: 'reportExpensesCategoryBranch',
      component: reportExpensesCategoryBranchPage,
      beforeEnter: requireAuth
    },
    {
      path: '/sat-xml-download',
      name: 'SatXMLDownloadPage',
      component: SatXMLDownloadPage,
      beforeEnter: requireAuth
    },
    {
      path: '/keywords',
      name: 'Keywords',
      component: keywordsPage,
      beforeEnter: requireAuth
    },
    {
      path: '/reportsByConcept',
      name: 'reportsByConceptPage',
      component: reportsByConceptPage,
      beforeEnter: requireAuth
    },
    {
      path: '/report-comparative',
      name: 'reportComparativePage',
      component: reportComparativePage,
      beforeEnter: requireAuth
    },
    {
      path: '/report-ExpenseTracking',
      name: 'reportExpenseTrackingPage',
      component: reportExpenseTrackingPage,
      beforeEnter: requireAuth
    },
    {
      path: '/expensesPayable',
      name: 'expensesPayablePage',
      component: expensesPayablePage,
      beforeEnter: requireAuth
    },
    {
      path: '/annualExpensesByEmployedReport',
      name: 'annualExpensesByEmployedReport',
      component: annualExpensesByEmployedReportPage,
      beforeEnter: requireAuth
    },
    {
      path: '/expensesPaid',
      name: 'expensesPaidPage',
      component: expensesPaid,
      beforeEnter: requireAuth
    },
    {
      path: '/advances',
      name: 'advancesPage',
      component: advancesPage,
      beforeEnter: requireAuth
    },
    {
      path: '/contact',
      name: 'contactPage',
      component: contactPage,
      beforeEnter: requireAuth
    },
    {
      path: '/pettyCash',
      name: 'pettyCashPage',
      component: pettyCashPage,
      beforeEnter: requireAuth
    },
    {
      path: '/request-pettyCash',
      name: 'requestPettyCashPage',
      component: requestPettyCashPage,
      beforeEnter: requireAuth
    },
    {
      path: '/amexCard',
      name: 'amexCardPage',
      component: amexCardPage,
      beforeEnter: requireAuth
    },
    {
      path: '/verifyEFOS',
      name: 'verifyEFOSPage',
      component: verifyEFOSPage,
      beforeEnter: requireAuth
    },
    // send an between "attach" or "watch"
    {
      path: '/expenses/files/:action/:id',
      name: 'attachFilesPage',
      component: attachFilesPage,
      beforeEnter: requireAuth
    },
    {
      path: '/reservations/:type',
      name: 'reservationsPage',
      component: reservationsPage,
      beforeEnter: requireAuth
    },
    {
      path: '/logout',
      beforeEnter: logout
    },
    {
      path: '*',
      beforeEnter: handleNotFound
    },
    {
      path: '/expensesRequest',
      name: 'viaticRequestPage',
      component: viaticRequestPage,
      beforeEnter: requireAuth
    },
    {
      path: '/cashier',
      name: 'cashierpage',
      component: cashierPage,
      beforeEnter: requireAuth
    },
    {
      path: '/representatives',
      name: 'representativesPage',
      component: representativesPage,
      beforeEnter: requireAuth
    },
    {
      path: '/search',
      name: 'generalSearchPage',
      component: generalSearchPage,
      beforeEnter: requireAuth,
      props: true
    },
    {
      path: '/vehicles',
      name: 'Vehicles',
      component: () => import('../container-components/vehicles/Vehicles'),
      beforeEnter: requireAuth
    },
    {
      path: '/advances-request',
      name: 'advancesRequest',
      component: advancesRequest,
      beforeEnter: requireAuth,
      props: true
    },
    ...Approvals(requireAuth),
    ...GeneralConfig(requireAuth),
    ...GeneralReports(requireAuth),
    ...HelpCenter(requireAuth)
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js